﻿import React from 'react';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import VeilederIofDto from '../Models/VeilederIofDto';
import { connect } from 'react-redux';
import { VeilederIofAppState } from '../Store';
import contentResolver, { resolveLinkCollection } from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { Ekstraboks } from '../Models/Resultat/Ekstraboks';
import { BoksEkstraboks } from '../../VeilederInntektOgFormue/Ids';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';

interface ResultOwnProps {
    ekstraboks: Ekstraboks | undefined;
    sats: string;
}

type ResultatProps = MapStateToProps & ResultOwnProps;

class EkstraboksComponent extends React.PureComponent<ResultatProps> {
    constructor(props: ResultatProps) {
        super(props);
    }
    componentDidMount(): void {
        updateLiveMessage();
    }

    render(): JSX.Element | null {
        const { ekstraboks, epiContext, sats } = this.props;

        if (ekstraboks !== undefined) {
            const valuesMap = new Map<string, string>();
            valuesMap.set('${sats}', sats);

            return (
                <div
                    id={BoksEkstraboks}
                    className="c-veileder__panel c-veileder__panel--ekstraboks c-veileder__panel--white-aubergine"
                >
                    <div className="c-veileder__panel-row">
                        <div className="c-veileder__content c-veileder__content-vertical">
                            <div className="c-veileder__content--header">
                                <h3 className="c-veileder__tittel c-veileder__tittel--resultat">
                                    {contentResolver(epiContext, ekstraboks.tittelLaerlinger)}
                                </h3>
                            </div>
                            <div className="c-veileder__content-vertical--textarea">
                                <p>{contentResolver(epiContext, ekstraboks.ingressLaerlinger, undefined, valuesMap)}</p>
                            </div>
                            <div className="c-veileder__content-vertical--linkarea c-veileder__content--with-space-mobile">
                                {resolveLinkCollection(
                                    epiContext,
                                    ekstraboks.lenkeLaerlinger,
                                    'c-veileder__linkwrapper',
                                    'c-knapp c-knapp--lenke c-knapp--artikkellenke c-knapp--icon-after c-knapp--pil-hoyre-aubergine',
                                )}
                            </div>
                        </div>
                        <div className="c-veileder__content c-veileder__content-vertical">
                            <div className="c-veileder__content--header">
                                <h3 className="c-veileder__tittel c-veileder__tittel--resultat">
                                    {contentResolver(epiContext, ekstraboks.tittelVideregaende)}
                                </h3>
                            </div>
                            <div className="c-veileder__content-vertical--textarea">
                                <p>{contentResolver(epiContext, ekstraboks.ingressVideregaende)}</p>
                            </div>
                            {ekstraboks.lenkeVideregaende && (
                                <div className="c-veileder__content-vertical--linkarea c-veileder__content--with-space-mobile">
                                    {resolveLinkCollection(
                                        epiContext,
                                        ekstraboks.lenkeVideregaende,
                                        'c-veileder__linkwrapper',
                                        'c-knapp c-knapp--lenke c-knapp--artikkellenke c-knapp--icon-after c-knapp--pil-hoyre-aubergine',
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            );
        }

        return null;
    }
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederIofDto>;
}

export default connect(
    (state: VeilederIofAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
        };
    },
)(EkstraboksComponent);
